



























































































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';
import {mapGetters, mapActions} from 'vuex';

@Component({
  name: 'DashboardOneApartmentTile',
  components: {
    VLazyImage,
  },
  props: {
    apartmentTitleText: {
      type: String,
      default: '',
    },
    currencyText: {
      type: String,
      default: '',
    },
    apartmentTexts: {
      type: Object,
      default: () => {},
    },
    apartmentData: {
      type: Object,
      default: () => {},
    },
  },
  data()  {
    return {
      fixit: 'Квартира',
    };
  },
  computed: {
    ...mapGetters('profile', ['myApartments']),
    actualListApartments() {
      if (this.myApartments.length > 0) {
        return this.myApartments.slice(0, 3);
      }
    },
  },
  methods: {},
})
export default class DashboardOneApartmentTile extends Vue {}
